import { JobPostDecisionReason } from "@api/shared-runtime/enums";

export const WITHDRAWAL_REASONS: {
  id: JobPostDecisionReason;
  label: string;
}[] = [
  { id: JobPostDecisionReason.Pay, label: "Pay" },
  { id: JobPostDecisionReason.Location, label: "Location" },
  { id: JobPostDecisionReason.Schedule, label: "Schedule" },
  { id: JobPostDecisionReason.Specialty, label: "Specialty" },
  { id: JobPostDecisionReason.Facility, label: "Facility" },
  { id: JobPostDecisionReason.Responsibilities, label: "Responsibilities" },
  { id: JobPostDecisionReason.Qualifications, label: "Qualifications" },
  { id: JobPostDecisionReason.Other, label: "Other" },
];

/** Lookup map from reason enum value to its display label. */
export const WITHDRAWAL_REASON_LABELS: Record<JobPostDecisionReason, string> =
  Object.fromEntries(WITHDRAWAL_REASONS.map((r) => [r.id, r.label])) as Record<
    JobPostDecisionReason,
    string
  >;
